import _formatErrorMessage from "@mui/x-internals/formatErrorMessage";
export const areViewsEqual = (views, expectedViews) => {
  if (views.length !== expectedViews.length) {
    return false;
  }
  return expectedViews.every(expectedView => views.includes(expectedView));
};
export const applyDefaultViewProps = ({
  openTo,
  defaultOpenTo,
  views,
  defaultViews
}) => {
  const viewsWithDefault = views ?? defaultViews;
  let openToWithDefault;
  if (openTo != null) {
    openToWithDefault = openTo;
  } else if (viewsWithDefault.includes(defaultOpenTo)) {
    openToWithDefault = defaultOpenTo;
  } else if (viewsWithDefault.length > 0) {
    openToWithDefault = viewsWithDefault[0];
  } else {
    throw new Error(process.env.NODE_ENV !== "production" ? 'MUI X Date Pickers: The `views` prop must contain at least one view. ' + 'The date picker needs at least one view to display. ' + 'Add a valid view to the views array (e.g., ["year", "month", "day"]).' : _formatErrorMessage(153));
  }
  return {
    views: viewsWithDefault,
    openTo: openToWithDefault
  };
};